import Navbar from 'components/Page/Navbar';
import PageWrap from 'components/Page/PageWrap';
import ContentWrap from 'components/Page/ContentWrap';
import { Button } from 'primereact/button';
import { useAuth } from 'hooks/useAuth';
import { Navigate } from 'react-router-dom';

const Login = () => {
    const { status, error } = useAuth();

    if (status === 'loading') return <></>;
    if (status === 'success') return <Navigate to='/' />;

    return (
        <PageWrap>
            <Navbar />
            <ContentWrap>
                {status === 'error' && <h2>Error: {error}</h2>}
                <h2>Login to the UserDirectory before proceeding</h2>
                <a
                    href={`${
                        window.EXTERNAL_URI_USERDIRECTORY
                    }?callback=${encodeURIComponent(
                        window.location.href.replace('/login', '/')
                    )}`}
                >
                    <Button label='Login' />
                </a>
            </ContentWrap>
        </PageWrap>
    );
};

export default Login;
